import * as React from 'react';
import data from '../../assets/data/nivolinedata';
import { ResponsiveLine } from '@nivo/line'
import { array } from 'prop-types';

// DATA MUST CONFORM TO THIS FORMAT
// Array<{
//     id:   string | number
//     data: Array<{
//         x: number | string | Date
//         y: number | string | Date
//     }>
// }>

// const theme = ;


export default class PerceptionScatterGraph extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      lineColor: props.lineColor,
      pointColor: props.pointColor
    }
    this.handleMouseClick = this.handleMouseClick.bind(this);
    this.getPerceptionCategory = this.getPerceptionCategory.bind(this);
  }

  determineColor = point => {
    // color calculations here
    if (point.x > 50) {
      return "#acff24";
    } else {
      return "#ff0033";
    }
  }

  mapDataToXY() {
    // convert fetched data to fit nivo data structure
  }

  handleMouseClick = point => {
    // alert("CLicked point: " + point.data.xFormatted)
  }

  getPerceptionCategory = level => {
    if (level >= 0 && level <= 50) {
      return 'Urgent Attention Needed';
    }
    else if (level > 50 && level <= 60) {
      return 'Moderate Attention Needed';
    }
    else if (level > 60 && level <= 75) {
      return 'Low Attention Needed';
    }
    else if (level > 75 && level <= 100) {
      return 'No Attention Needed';
    } else {
      return 'You seem to have exceeded our bounds';
    }
  }
  componentDidMount() {
    // fetch actual data
  }

  render() {
    return (
      <div style={{ width: "100%", height: "100%" }}>
        <ResponsiveLine data={this.props.data}
          margin={{ top: 20, right: 20, bottom: 50, left: 60 }}
          xScale={{ type: 'point' }}
          yScale={{ type: 'linear', stacked: false, min: 0, max: 100 }}
          axisTop={null}
          axisRight={null}
          axis={{
            fontSize: "14px",
            tickColor: "#fa96a5",

          }}
          axisBottom={{
            orient: 'bottom',
            tickSize: 2,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'ASSESSMENTS',
            color: '#fff',
            legendOffset: 45,
            legendPosition: 'middle'
          }}
          axisLeft={{
            orient: 'left',
            tickSize: 2,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'PERCEPTION LEVEL',
            legendOffset: -50,
            legendPosition: 'middle'
          }}
          colors={this.state.lineColor}
          pointSize={14}
          pointColor={this.state.pointColor}

          pointBorderWidth={2}
          pointBorderColor={{ from: 'serieColor' }}
          pointLabel="y"
          pointLabelYOffset={-12}
          useMesh={false}
          // enableSlices="y"
          theme={{

            axis: {
              fontSize: "14px",
              tickColor: "#eee",
              ticks: {
                line: {
                  stroke: "#e7233d"
                },
                text: {
                  fill: "#ffffff"
                }
              },
              legend: {
                text: {
                  fill: "#aaaaaa",
                  fontFamily: "Roboto Condensed",
                  fontWeight: 'bold'
                }
              }
            },
            grid: {
              line: {
                stroke: "#777"
              }
            }
          }}

          //   sliceTooltip={({ slice }) => {
          //     return (
          //       <div
          //         style={{
          //           background: this.state.pointColor,
          //           padding: '9px 12px',
          //           borderRadius: '5px',
          //         }}
          //       >
          //         {/* <div>Assessment: {slice.id}</div> */}
          //         {slice.points.map(point => (
          //           <div
          //             key={point.id}
          //             style={{
          //               color: "#000",
          //               padding: '3px 0',
          //               fontSize: "14px"
          //             }}
          //           >

          //             <strong>Assessment: </strong> {point.data.xFormatted}
          //             <br />
          //             <strong>Perception Level: </strong> {point.data.yFormatted}
          //           </div>
          //         ))}
          //       </div>
          //     );
          //   }}
          tooltip={(e) => {
            return (
              <div
                style={{
                  background: this.state.pointColor,
                  padding: '9px 12px',
                  borderRadius: '5px',
                }}>
                <div
                  style={{
                    color: "#000",
                    padding: '3px 0',
                    fontSize: "14px",
                    background: '#3ee9f7'
                  }}
                >

                  <strong>Assessment: </strong> {e.point.data.xFormatted}
                  <br />
                  <strong>Perception Level: </strong> {e.point.data.yFormatted}
                  <br />
                  <strong>Perception Category: </strong> {this.getPerceptionCategory(e.point.data.yFormatted)}
                </div>
              </div>
            )
          }}
          legends={[
            // {
            //     anchor: 'bottom-right',
            //     direction: 'column',
            //     justify: false,
            //     translateX: 100,
            //     translateY: 0,
            //     itemsSpacing: 0,
            //     itemDirection: 'left-to-right',
            //     itemWidth: 80,
            //     itemHeight: 20,
            //     itemOpacity: 0.75,
            //     symbolSize: 12,
            //     symbolShape: 'circle',
            //     symbolBorderColor: 'rgba(0, 0, 0, .5)',
            //     effects: [
            //         {
            //             on: 'hover',
            //             style: {
            //                 itemBackground: 'rgba(0, 0, 0, .03)',
            //                 itemOpacity: 1
            //             }
            //         }
            //     ]
            // }
          ]}
          onClick={this.handleMouseClick}
        />
      </div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/common/DataViz/studentPerceptionGraph.Component.js